import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getNewBusinesses } from "../../../api/business";

export const fetchBusiness = createAsyncThunk(
  "fetchBusiness",
  async (payload) => {
    const res = await getNewBusinesses(payload);
    return res;
  }
);

const initialState = {
  isLoading: false,
  res: {
    items: [],
  },
  error: null,
};

const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusiness.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBusiness.fulfilled, (state, action) => {
        state.isLoading = false;
        state.res.items = [...state.res.items, ...(action?.payload?.items || [])];
      })
      .addCase(fetchBusiness.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { reset } = businessSlice.actions;
export { businessSlice };
